export async function apiPost(route,body, options = {}) {

   try {
    return await fetch(route, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
    } catch (err) {
      console.error(err)
    }
}